import { useState } from "react"
import { useDispatch } from "react-redux"

import {
  IMG_BOT_CONVERSATION,
  IMG_LIVE_CHAT_BG,
} from "../../../../../data/assets"

import { updateLiveChatState } from "../../../../../data/store/liveChatSlice"
import { LiveChatEnabled } from "../../../../../data/store/overviewSlice"
import liveChatInitialState from "../../../../../data/store/liveChatSlice/initialState"

import { Modal, Typography, Button, Row, Col, theme, notification } from "antd"
import Notify, { notify } from "../../../../components/Notify"

const LiveChatDisabled = ({ tenantId, active }) => {
  const { token: themeToken } = theme.useToken()
  const dispatch = useDispatch()
  const [showDialog, setShowDialog] = useState(false)

  const handleCloseDialog = (e, reason) => {
    if (reason !== "backdropClick") setShowDialog(false)
  }

  const handleOpenDialog = (e, reason) => {
    if (process.env.REACT_APP_LIVE_CHAT_DEMO_VIDEO) setShowDialog(true)
    else
      notify.error({ message: "Video url is missing" })
  }

  const handleLiveChats = (event) => {
    dispatch(
      LiveChatEnabled({
        tenantId,
        status: true,
      })
    )
      .unwrap()
      .then(() => {
        dispatch(updateLiveChatState(liveChatInitialState))
      })
  }

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        padding: 16,
      }}
    >
      <Notify />
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundImage: `url(${IMG_LIVE_CHAT_BG})`,
          backgroundPosition: "center",
          backgroundSize: "contain",
          filter: "blur(4px)",
          opacity: 0.3,
        }}
      />
      <div
        style={{
          padding: 16,
          maxWidth: 600,
          borderRadius: 8,
          background: themeToken.colorBgContainer,
          zIndex: 1,
        }}
      >
        <Row gutter={[16, 16]} justify="center" align="middle">
          <Col xs={24} sm={12} md={10} lg={10}>
            <img
              src={IMG_BOT_CONVERSATION}
              alt="enable-live-chat-popup"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
              className="responsive-img"
            />
          </Col>
          <Col xs={24}>
            <Typography.Text
              style={{
                textAlign: "center",
                display: "block",
                maxWidth: 500,
                margin: "auto",
              }}
            >
              Enable human assist to engage with your customers in real-time
            </Typography.Text>
          </Col>
          <Col xs={24} md={12} xl={8}>
            <Button
              size="large"
              type="primary"
              block
              onClick={handleLiveChats}
              style={{ marginBottom: 8 }}
            >
              Enable human assist
            </Button>
            {process.env.REACT_APP_LIVE_CHAT_DEMO_VIDEO && (
              <Button
                size="large"
                onClick={handleOpenDialog}
                type="primary"
                block
                icon={<i className="ri-play-circle-line" />}
              >
                Watch the video
              </Button>
            )}
          </Col>
        </Row>
      </div>

      <Modal
        open={showDialog}
        onCancel={handleCloseDialog}
        footer={null}
        centered
        width={800}
        closeIcon={<i className="ri-close-line" />}
      >
        <iframe
          src={process.env.REACT_APP_LIVE_CHAT_DEMO_VIDEO}
          title="Orimon AI"
          width="100%"
          height={420}
          frameBorder={0}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </Modal>
    </div>
  )
}

export default LiveChatDisabled
